<div class="tabview">

  <!-- ===== NAVIGATION ===== -->
  <div class="tabview-nav">

    <!-- Médicaments -->
    <div [class.active]="tabIndex === 0" (click)="changeTab(0)">
      <span>
        <i class="fas fa-capsules"></i>
        Médicaments
      </span>
      <span class="badge">{{ prescription.medics?.length || 0 }}</span>
    </div>

    <!-- Biologies -->
    <div [class.active]="tabIndex === 1" (click)="changeTab(1)">
      <span>
        <i class="fas fa-flask"></i>
        Biologies
      </span>
      <span class="badge">{{ prescription.biologies?.length || 0 }}</span>
    </div>

    <!-- Radiologies -->
    <div *ngIf="doctor.consultationRadiology || prescription.radiologies"
         [class.active]="tabIndex === 2"
         (click)="changeTab(2)">
      <span>
        <i class="fas fa-x-ray"></i>
        Radiologies
      </span>
      <span class="badge">{{ prescription.radiologies?.length || 0 }}</span>
    </div>

    <!-- Bouton Modèles -->
    <button
    *ngIf="model"
      class="model-trigger-btn ms-auto"
      (click)="toggleModels()"
      [class.active]="open"
      type="button">
      <i class="feather-more-horizontal"></i>
      <span>Modèles des  {{tabIndex===0?' Médicaments':tabIndex===1?' Biologies':' Radiologies'}}</span>

    </button>

  </div>

  <!-- ===== CONTENU ===== -->
  <div class="tabview-content">

    <app-medic-prescription-form
      *ngIf="tabIndex === 0"
      [submitted]="submitted"
      (validation)="validity.medics = $event"
      [(medicPrescriptionItems)]="prescription.medics"
      (medicPrescriptionItemsChange)="_onChange()">
    </app-medic-prescription-form>

    <app-biology-prescription-form
      *ngIf="tabIndex === 1"
      [submitted]="submitted"
      (validation)="validity.biologies = $event"
      [(biologyPrescriptionItems)]="prescription.biologies"
      (biologyPrescriptionItemsChange)="_onChange()">
    </app-biology-prescription-form>

    <app-radiology-prescription-form
      *ngIf="tabIndex === 2"
      [submitted]="submitted"
      (validation)="validity.radiologies = $event"
      [(radiologyPrescriptionItems)]="prescription.radiologies"
      (radiologyPrescriptionItemsChange)="_onChange()">
    </app-radiology-prescription-form>

  </div>

</div>